/* eslint-disable */
const ls = require('local-storage');

import services from 'services';
import jwtDecode from 'jwt-decode';
import * as types from './mutation-types';

export default {
  fetchState: ({ dispatch }) => {
    const shopToken = ls.get('shopToken');
    if (shopToken) {
      dispatch('loginWithShopToken', shopToken);
      return shopToken;
    }
    return null;
  },
  loginWithShopToken: async ({ commit }, shopToken) => {
    commit(types.LOGIN, { shop: jwtDecode(shopToken), shopToken: shopToken });
  },
  /**
   * Adds shop to state and set state.authenticated value to true
   */
  handleMagicLinkToken: async ({ commit, dispatch, rootGetters }, token) => {
    try {
      await services.ShopAuthService.loginWithMagicLinkToken(token);
      dispatch('loginWithShopToken', token);
    } catch {
      throw new Error('ShopTokenError');
    }
  },
  logout: ({ commit, dispatch }) => {
    commit(types.RESET);
  },
  updateShop: async ({ commit }) => {
    const shop = await services.ShopAuthService.getCurrentShopInfos();
    commit(types.UPDATE_SHOP, shop);
  },
};
